var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"overlay-div-contact",style:({
      'background-image': `url(${_vm.imgHeader})`,
      '--panelImgColor': _vm.rgbaTransparent
    })},[_c('div',{staticClass:"text-light overlay-text d-flex flex-column justify-content-center pl-xl-5 mx-xl-5"},[_c('h1',{staticClass:"text-left"},[_vm._v(_vm._s(_vm.dataHeader))]),_c('p',[_c('b',[_c('span',{staticClass:"pointer",on:{"click":function($event){return _vm.$router.push('/')}}},[_vm._v(_vm._s(_vm.$t('nav.home')))]),_vm._v(" >> "+_vm._s(_vm.dataHeader)+" ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }